// extracted by mini-css-extract-plugin
export default {"info":"ErrorMessage_info__-fK79"};